
import axios from 'axios'
const state = {}
const mutations = {}

import config from '@/../config'

const defaultErrorHandler = (error =>  Promise.reject(error.response))

const actions = {
	GET_NOVIDADES ({commit}, payload) {
		return axios.get(config.apiUrl + config.versoes[0]+ '/novidades/')
		.then(response => {
			if(response.data) {
				response.data.sort((a, b) =>
					+new Date(b.data) - +new Date(a.data)
				)
			}
			return response.data
		})
		.catch(error => {
			return Promise.reject(error.response);
		})
	},
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/novidades.js